import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Button } from 'components/buttons/Button/Button';
import { ReactComponent as SVG } from 'images/card-decor.svg';
import { Link } from 'react-router-dom';

gsap.registerPlugin(ScrollTrigger);

const ProductCard = ({ data, index }) => {
    useEffect(() => {
        // TODO change parallax
        // gsap.utils.toArray('.product-card__image-bg').forEach(layer => {
        //     const depth = 0.1;
        //     const movement = -(layer.offsetHeight * depth);
        //     gsap.timeline({
        //         scrollTrigger: {
        //             trigger: 'main',
        //             start: 'top top',
        //             end: 'bottom top',
        //             scrub: true,
        //         },
        //     }).to(layer, { y: movement, ease: 'none' }, 0);
        // });
        // gsap.utils.toArray('.product-card__image-bg').forEach(element => {
        //     gsap.to(element, {
        //         ease: 'none',
        //         scrollTrigger: {
        //             trigger: element,
        //             start: 'bottom bottom',
        //             end: 'top top',
        //             scrub: true,
        //             onUpdate: self => {
        //                 const scrollPercentage = self.progress * 16;
        //                 gsap.to(element, { yPercent: scrollPercentage });
        //             },
        //         },
        //     });
        // });
    }, []);

    const {
        preview_title,
        preview_text,
        preview_link_text,
        preview_image,
        slug,
        logo,
        preview_description,
        preview_button_text,
    } = data;

    const number = String(index + 1).padStart(2, '0');
    const description = preview_text || preview_description;
    const button_text = preview_link_text || preview_button_text;

    return (
        <Link to={slug} className={`product-card ${index % 2 !== 0 ? 'product-card--reverse' : ''}`}>
            <div className="product-card__image" data-index={'• ' + number}>
                <SVG />
                <img src={preview_image} alt="product-item" className="product-card__image-bg" />
                {logo && (
                    <div className="product-card__image-logo">
                        <img src={logo} alt="product-logo" />
                    </div>
                )}
            </div>
            <div className="product-card__content">
                <h3>{preview_title}</h3>
                <p className="body1">{description}</p>
                <button className="button learn-more-arrow has-children">
                    <div></div>
                    <span>{button_text}</span>
                </button>
            </div>
        </Link>
    );
};

export default ProductCard;
